import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(() =>
  createStyles({
    tooltip: {
      fontFamily: 'Source Sans Pro',
      fontWeight: 'bold',
      textAlign: 'center',
    },
  }),
)
